import { call, put } from 'redux-saga/effects'
import TeamActions from 'Redux/TeamRedux'
import SelectionActions from 'Redux/SelectionRedux'
import { BuildErrorMsg } from './ApiHelpers'
import { TeamRespTransform } from 'Transforms/Team'

export function * onTeamsRequest (api, action) {
  const resp = yield call(api.getTeams)
  if (resp.ok) {
    yield put(TeamActions.teamsListSuccess(TeamRespTransform(resp.data)))
    let activeTeam = {}
    let activeProject = {}
    resp.data.every(team => {
      const project = team.projects.find(project => (
        project.id === Number(action.currentProjectId)
      ))
      if (project) {
        activeProject = project
        activeTeam = team
        return false
      }
      return true
    })
    if (activeTeam.id) {
      yield put(SelectionActions.selectionsAddActiveTeam(activeTeam.id))
      yield put(
        SelectionActions.selectionsSetData('activeProject', activeProject))
    } else if(resp.data.length > 0) {
      yield put(SelectionActions.selectionsAddActiveTeam(resp.data[0].id))
    }
  } else {
    yield put(TeamActions.teamsListFailure(BuildErrorMsg(resp)))
  }
}




// WEBPACK FOOTER //
// ./src/Sagas/TeamSagas.js